import { createIcon } from '@chakra-ui/react';

export const Print = createIcon({
  displayName: 'Print',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path d="M4.83398 4.66668H11.1673V3.33334C11.1673 2.00001 10.6673 1.33334 9.16732 1.33334H6.83398C5.33398 1.33334 4.83398 2.00001 4.83398 3.33334V4.66668Z" stroke="#6E6789" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10.6673 10V12.6667C10.6673 14 10.0007 14.6667 8.66732 14.6667H7.33398C6.00065 14.6667 5.33398 14 5.33398 12.6667V10H10.6673Z" stroke="#6E6789" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14 6.66666V9.99999C14 11.3333 13.3333 12 12 12H10.6667V9.99999H5.33333V12H4C2.66667 12 2 11.3333 2 9.99999V6.66666C2 5.33332 2.66667 4.66666 4 4.66666H12C13.3333 4.66666 14 5.33332 14 6.66666Z" stroke="#6E6789" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11.3327 10H10.526H4.66602" stroke="#6E6789" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4.66602 7.33334H6.66602" stroke="#6E6789" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </>
  ),
});
